// extracted by mini-css-extract-plugin
export default {"wrapper":"Video_wrapper__E87Q4","video":"Video_video__lR9XK"};